import styled from "styled-components";
import type { FunctionComponent, } from "react";
import { VBox, Text as Tx, } from "@bracket/ui";

export const RestrictedArea: FunctionComponent = () => {
	return (
		<Brace>
			<Tx>Uhh oh... you're not authorized to access this area.</Tx>
		</Brace>
	);
};

const Brace = styled(VBox)`
	align-items: center;
	justify-content: center;
`;
